import React, { useState } from 'react';
import { AutoComplete } from 'antd';
import { useStockSearch } from '../../../hooks/useStockSearch';
import { formatDecimal } from '../../../utils/numberFormat';

interface Props {
  value?: string;
  /** Symbols already used elsewhere on the form: not offered again. */
  exclude: string[];
  onPick: (symbol: string) => void;
  placeholder?: string;
  disabled?: boolean;
  /** Clears the box after a pick (adding to a list) instead of showing the pick (editing a row). */
  clearOnPick?: boolean;
  style?: React.CSSProperties;
}

const TickerPicker: React.FC<Props> = ({
  value,
  exclude,
  onPick,
  placeholder = 'Ticker',
  disabled,
  clearOnPick,
  style,
}) => {
  const { searchResults, handleSearch } = useStockSearch();
  const [text, setText] = useState<string | undefined>(undefined);
  const options = searchResults
    .filter((s) => !exclude.includes(s.symbol))
    .slice(0, 20)
    .map((s) => ({
      value: s.symbol,
      label: s.price ? `${s.symbol} — ${formatDecimal(s.price, 2)}` : s.symbol,
    }));

  return (
    <AutoComplete
      value={text ?? value}
      options={options}
      onSearch={(q) => {
        setText(q.toUpperCase());
        handleSearch(q.toUpperCase());
      }}
      onSelect={(sym: string) => {
        onPick(sym);
        setText(clearOnPick ? '' : undefined);
      }}
      onBlur={() => setText(undefined)}
      placeholder={placeholder}
      disabled={disabled}
      style={{ width: '100%', ...style }}
      aria-label={placeholder}
    />
  );
};

export default TickerPicker;
